import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["firms"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      printableFilevineSectionsList: build.query<
        PrintableFilevineSectionsListApiResponse,
        PrintableFilevineSectionsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/firms/${queryArg.firmId}/printable-filevine-sections/`,
        }),
        providesTags: ["firms"],
      }),
      printableFilevineSectionsCreate: build.mutation<
        PrintableFilevineSectionsCreateApiResponse,
        PrintableFilevineSectionsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/firms/${queryArg.firmId}/printable-filevine-sections/`,
          method: "POST",
          body: queryArg.createPrintableFilevineSectionSchema,
        }),
        invalidatesTags: ["firms"],
      }),
      printableFilevineSectionsRetrieve: build.query<
        PrintableFilevineSectionsRetrieveApiResponse,
        PrintableFilevineSectionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/firms/${queryArg.firmId}/printable-filevine-sections/${queryArg.id}/`,
        }),
        providesTags: ["firms"],
      }),
      printableFilevineSectionsUpdate: build.mutation<
        PrintableFilevineSectionsUpdateApiResponse,
        PrintableFilevineSectionsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/firms/${queryArg.firmId}/printable-filevine-sections/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.updatePrintableFilevineSectionSchema,
        }),
        invalidatesTags: ["firms"],
      }),
      printableFilevineSectionsPartialUpdate: build.mutation<
        PrintableFilevineSectionsPartialUpdateApiResponse,
        PrintableFilevineSectionsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/firms/${queryArg.firmId}/printable-filevine-sections/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdatePrintableFilevineSectionSchema,
        }),
        invalidatesTags: ["firms"],
      }),
      printableFilevineSectionsDestroy: build.mutation<
        PrintableFilevineSectionsDestroyApiResponse,
        PrintableFilevineSectionsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/firms/${queryArg.firmId}/printable-filevine-sections/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["firms"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type PrintableFilevineSectionsListApiResponse =
  /** status 200  */ PrintableFilevineSectionSchema[];
export type PrintableFilevineSectionsListApiArg = {
  firmId: string;
};
export type PrintableFilevineSectionsCreateApiResponse =
  /** status 201  */ PrintableFilevineSectionSchema;
export type PrintableFilevineSectionsCreateApiArg = {
  firmId: string;
  createPrintableFilevineSectionSchema: CreatePrintableFilevineSectionSchema;
};
export type PrintableFilevineSectionsRetrieveApiResponse =
  /** status 200  */ PrintableFilevineSectionSchema;
export type PrintableFilevineSectionsRetrieveApiArg = {
  firmId: string;
  id: string;
};
export type PrintableFilevineSectionsUpdateApiResponse =
  /** status 200  */ PrintableFilevineSectionSchema;
export type PrintableFilevineSectionsUpdateApiArg = {
  firmId: string;
  id: string;
  updatePrintableFilevineSectionSchema: UpdatePrintableFilevineSectionSchema;
};
export type PrintableFilevineSectionsPartialUpdateApiResponse =
  /** status 200  */ PrintableFilevineSectionSchema;
export type PrintableFilevineSectionsPartialUpdateApiArg = {
  firmId: string;
  id: string;
  patchedUpdatePrintableFilevineSectionSchema: UpdatePrintableFilevineSectionSchema2;
};
export type PrintableFilevineSectionsDestroyApiResponse = unknown;
export type PrintableFilevineSectionsDestroyApiArg = {
  firmId: string;
  id: string;
};
export type PrintableFilevineSectionSchema = {
  id: string | string;
  firm_id: string | string;
  section_name: string;
  section_url_component: string;
  created_at: string;
  modified_at: string;
};
export type CreatePrintableFilevineSectionSchema = {
  firm_id: string | string;
  section_name: string;
  section_url_component: string;
};
export type UpdatePrintableFilevineSectionSchema = {
  section_name?: string | null;
  section_url_component?: string | null;
};
export type UpdatePrintableFilevineSectionSchema2 = {
  section_name?: string | null;
  section_url_component?: string | null;
};
export const {
  usePrintableFilevineSectionsListQuery,
  usePrintableFilevineSectionsCreateMutation,
  usePrintableFilevineSectionsRetrieveQuery,
  usePrintableFilevineSectionsUpdateMutation,
  usePrintableFilevineSectionsPartialUpdateMutation,
  usePrintableFilevineSectionsDestroyMutation,
} = injectedRtkApi;
